module.exports = {
          srcSet: __webpack_public_path__ + "public/images/088103e1150d9ad4775ddf1228b1ffa0-1774.jpg"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/088103e1150d9ad4775ddf1228b1ffa0-1774.jpg",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/088103e1150d9ad4775ddf1228b1ffa0-1774.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/088103e1150d9ad4775ddf1228b1ffa0-1774.jpg"},
          
          width: 1774,
          height: 887
        }